module.exports = __webpack_public_path__ + "static/media/man_han_saf_foo.4d0fca7d.png";